import { render, staticRenderFns } from "./FilmartKnowhowButton.vue?vue&type=template&id=06e52f2f&scoped=true&"
var script = {}
import style0 from "./FilmartKnowhowButton.vue?vue&type=style&index=0&id=06e52f2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e52f2f",
  null
  
)

export default component.exports